import React from "react";
import { Images } from "lucide-react";

import { EllipsisMenu } from "../../../../components/menu/ellipsis/EllipsisMenu";

import "./AlbumThumbnailCard.css";

export default function AlbumThumbnailCard({
  album,
  onClick,
  showMenu = false,
  menuOptions = [],
  disabled = false,
  className = "",
}) {
  const albumId = album?.albumId ?? album?.albumTag;
  const title = album?.title || "Untitled Album";

  const thumbnailUrl =
    album?.thumbnailUrl || album?.coverUrl || album?.coverImageUrl || null;

  const photoCount = Math.max(
    0,
    Number(album?.photoCount ?? album?.imageCount ?? 0) || 0,
  );

  const hasMultipleImages = photoCount > 1;
  const showActions = showMenu && menuOptions.length > 0;
  const canOpen = !disabled && albumId != null && Boolean(onClick);

  const handleOpen = () => {
    if (!canOpen) return;
    onClick(albumId);
  };

  return (
    <article
      className={["album-card", disabled && "album-card--disabled", className]
        .filter(Boolean)
        .join(" ")}
    >
      <button
        type="button"
        className="album-card__action"
        onClick={handleOpen}
        disabled={!canOpen}
        aria-label={`Open ${title}`}
      >
        <div className="album-card__thumbnail">
          {thumbnailUrl ? (
            <img
              src={thumbnailUrl}
              alt=""
              className="album-card__image"
              draggable={false}
              loading="lazy"
              decoding="async"
            />
          ) : (
            <div className="album-card__placeholder">
              <Images size={28} strokeWidth={1.8} aria-hidden="true" />
            </div>
          )}

          {hasMultipleImages && (
            <div className="album-card__multiple-icon" aria-hidden="true">
              <span className="album-card__multiple-icon-back" />
              <span className="album-card__multiple-icon-front" />
            </div>
          )}

          <span className="album-card__photo-count">
            <Images size={13} strokeWidth={2} aria-hidden="true" />
            {photoCount}
          </span>
        </div>
      </button>

      {showActions && (
        <div
          className="album-card__menu"
          onClick={(event) => event.stopPropagation()}
        >
          <EllipsisMenu
            options={menuOptions}
            position="right"
            disabled={disabled}
          />
        </div>
      )}
    </article>
  );
}
